import React, { useCallback, useState, useEffect } from "react";
import { Redirect } from "react-router";

import clsx from "clsx";

import { TranslatedText } from "@plex/culture-react";
import { Button, Overlay } from "@plex/react-components";

import { commonMessages } from "infrastructure/localization";
import { useUserContext, useLocalizedValues, useLocalizerWithFallback, useAppContext } from "ui/hooks";

import styles from "./SignIn.module.scss";

export const SignIn: React.FC = () => {
  const appContext = useAppContext();
  const userContext = useUserContext();
  const error = userContext.getError();

  const localizer = useLocalizerWithFallback();

  const localizedValues = useLocalizedValues(() => ({
    signInProcessing: commonMessages.info("signInProcessing")
  }));

  const [statusMessage, setStatusMessage] = useState<string | undefined>(undefined);

  useEffect(() => {
    const error = userContext.getError();

    if (error?.value) {
      setStatusMessage(localizer({ messageId: { value: error?.value } }));
    }
  }, [userContext, localizer]);

  const signInExecute = useCallback(() => {
    setStatusMessage(localizedValues.signInProcessing);
    userContext.initiateAuthentication(true);
  }, [userContext, localizedValues.signInProcessing]);

  if (userContext.isAuthorized()) {
    return <Redirect to={"/"} />;
  } else {
    return (
      <div className={clsx(styles.base, !error && styles.hasErrors)}>
        <h1 className={styles.appName}>{appContext.appInfo.appName}</h1>
        {statusMessage && <h5>{statusMessage}</h5>}
        <Button onClick={signInExecute}>
          <TranslatedText messageId={commonMessages.action("signIn").value} />
        </Button>
        <Overlay show={userContext.isAuthenticating() || userContext.isAuthorizing()} showSpinner />
      </div>
    );
  }
};
